/** PUBLIC ENV */
export const TARGET_ENV = process.env.NEXT_PUBLIC_TARGET_ENV as string;
export const MRT_ORIGIN = process.env.NEXT_PUBLIC_MRT_ORIGIN as string;
export const EXPERIENCES_ORIGIN = process.env.NEXT_PUBLIC_EXPERIENCES_ORIGIN as string;
export const TRANSPORTATION_ORIGIN = process.env.NEXT_PUBLIC_TRANSPORTATION_ORIGIN as string;
export const AUTH_ORIGIN = process.env.NEXT_PUBLIC_AUTH_ORIGIN as string;
export const MEMBER_ORIGIN = process.env.NEXT_PUBLIC_MEMBER_ORIGIN as string;
export const PARTNER_ORIGIN = process.env.NEXT_PUBLIC_PARTNER_ORIGIN as string;
export const API_ENDPOINT = process.env.NEXT_PUBLIC_API_ENDPOINT as string;
export const EXPERIENCES_API_ENDPOINT = process.env.NEXT_PUBLIC_EXPERIENCES_API_ENDPOINT as string;
export const TRANSPORTATION_API_ENDPOINT = process.env
  .NEXT_PUBLIC_TRANSPORTATION_API_ENDPOINT as string;
export const NEXT_PUBLIC_TRANSPORTATION_LONG_TIMEOUT_API_ENDPOINT =
  process.env.NEXT_PUBLIC_TRANSPORTATION_LONG_TIMEOUT_API_ENDPOINT;
export const REVIEW_API_ENDPOINT = process.env.NEXT_PUBLIC_REVIEW_API_ENDPOINT as string;
export const ORDER_API_ENDPOINT = process.env.NEXT_PUBLIC_ORDER_API_ENDPOINT as string;
export const MEMBER_API_ENDPOINT = process.env.NEXT_PUBLIC_MEMBER_API_ENDPOINT as string;
export const MESSENGER_API_ENDPOINT = process.env.NEXT_PUBLIC_MESSENGER_API_ENDPOINT as string;
export const COUPON_API_ENDPOINT = process.env.NEXT_PUBLIC_COUPON_API_ENDPOINT as string;
export const RAILS_API_ENDPOINT = process.env.NEXT_PUBLIC_RAILS_API_ENDPOINT as string;
export const GOOGLE_KEY = process.env.NEXT_PUBLIC_GOOGLE_KEY as string;
export const KAKAO_KEY = process.env.NEXT_PUBLIC_KAKAO_KEY as string;
export const S3_ICONS_URL = process.env.NEXT_PUBLIC_S3_ICONS_URL as string;
export const DISCOVERY_API_ENDPOINT = process.env.NEXT_PUBLIC_DISCOVERY_API_ENDPOINT as string;

/** Marketing Log Keys */
export const KAKAO_PIXEL_KEY = process.env.NEXT_PUBLIC_KAKAO_PIXEL_KEY as string;
export const FACEBOOK_PIXEL_KEY = process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_KEY as string;
export const BRAZE_KEY = process.env.NEXT_PUBLIC_BRAZE_KEY as string;
export const CRITEO_KEY = process.env.NEXT_PUBLIC_CRITEO_KEY as string;
